import { render, staticRenderFns } from "./SalReceiptModal.vue?vue&type=template&id=c5bc987a&scoped=true&"
import script from "./SalReceiptModal.vue?vue&type=script&lang=js&"
export * from "./SalReceiptModal.vue?vue&type=script&lang=js&"
import style0 from "./SalReceiptModal.vue?vue&type=style&index=0&id=c5bc987a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bc987a",
  null
  
)

export default component.exports